import React from "react";
import "./styles.css";

const SendButton = ({ onClick, iconSrc, bgColor = "#2251ff" }) => {
  return (
    <button
      className="send-box"
      onClick={onClick}
      style={{ backgroundColor: bgColor }}
    >
      <img src={iconSrc} alt="send" loading="lazy" />
    </button>
  );
};

export default SendButton;
